/* eslint-disable react/no-array-index-key, no-underscore-dangle */
import React from 'react';
import { Helmet } from 'react-helmet';
import { hot } from 'react-hot-loader/root';
// import Lockr from 'lockr';
import {
  nativeFunction,
  callNativeFunction,
  OS,
} from '@/utils/detectDevice';
import onfire from '@/utils/nativeCallback';
import { DEVICE } from '@/constants';
import favicon from '@/assets/favicon.ico';
import AuthContext from './AuthContext';
import BasicRouter from './routes';
import './index.css';

OS.TYPE !== DEVICE.PC && callNativeFunction(nativeFunction.GET_IDENTITY)();
window.onfire = onfire;
console.log('');
// window.set_webview_token = (params) => {
//   OS.TYPE === DEVICE.PC ? setLocalStorage(params) : setWindowGlobal(params);
// };

const App = () => (
  <AuthContext.Provider value={{ login: false }}>
    <Helmet>
      <link rel="shortcut icon" href={favicon} />
    </Helmet>
    <BasicRouter />
  </AuthContext.Provider>
);

export default hot(App);
